import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/game-coins",
  },
  {
    path: "/game-coins",
    name: "game-coins",
    component: () => import("@/views/index.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/game-coins",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

router.beforeEach((_to, _from, next) => {
  next();
});

export default router;
